import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Sidebar } from "../components";
import { useAuthStore } from "../store";
import { useDisclosure } from "@nextui-org/react";
import { useEffect } from "react";
import { setupAxiosInterceptors } from "../config/client.axios.api";
import path from "../ultils/path";

const Layout = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  });
  const { token } = useAuthStore();
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    }
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // handle token expired
  useEffect(() => {
    setupAxiosInterceptors(navigate);
    // eslint-disable-next-line no-unused-vars
  }, []);

  // state of model next
  // update info account
  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();
  const dataModelUpdateInfo = { isOpen, onOpen, onOpenChange, onClose };

  // update password
  const {
    isOpen: isOpenUpdatePassword,
    onOpen: onOpenUpdatePassword,
    onOpenChange: onOpenChangePassword,
    onClose: onClosePassword,
  } = useDisclosure();

  const dataModelUpdatePassword = {
    isOpenUpdatePassword,
    onOpenUpdatePassword,
    onOpenChangePassword,
    onClosePassword,
  };

  // add account for store
  const {
    isOpen: isOpenAddAccountForStore,
    onOpen: onOpenAddAccountForStore,
    onOpenChange: onOpenChangeAddAccountForStore,
    onClose: onCloseAddAccountForStore,
  } = useDisclosure();

  const dataModelAddAccountForStore = {
    isOpenAddAccountForStore,
    onOpenAddAccountForStore,
    onOpenChangeAddAccountForStore,
    onCloseAddAccountForStore,
  };
  return (
    <QueryClientProvider client={queryClient}>
      {token ? (
        <div className="flex w-screen h-screen overflow-hidden bg-[#F3F4F6] ">
          <Sidebar
            dataModelUpdateInfo={dataModelUpdateInfo}
            dataModelUpdatePassword={dataModelUpdatePassword}
            dataModelAddAccountForStore={dataModelAddAccountForStore}
          />
          <div className="flex flex-col flex-grow overflow-hidden bg-[#F3F4F6] ">
            {/* <Header
              dataModelAddAccountForStore={dataModelAddAccountForStore}
              dataModelUpdateInfo={dataModelUpdateInfo}
              dataModelUpdatePassword={dataModelUpdatePassword}
            /> */}
            <main className="flex-grow max-sm:pb-[6vh] lg:p-6 p-0 max-sm:mt-[9vh] sm:mt-[14vh] md:mt-[17vh] lg:mt-0 bg-gray-100 overflow-auto">
              <Outlet />
            </main>
          </div>
        </div>
      ) : (
        <Outlet />
      )}
    </QueryClientProvider>
  );
};

export default Layout;
